export const COLUMN_HEADERS = {
  Country: "Country",
  "Enrollment Start": "Enrollment Start",
  "Number of Activated Sites": "# Sites",
  "Enrollment Duration": "Enrollment Period (Months)",
  "Number of Patients Screened": "# Participants Screened",
  "Number of Patients Enrolled": "# Participants Enrolled",
  "Number of Patients Completing Treatment": "# Participants Completed",
};
